var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stuck)?_c('div',{staticClass:"stuckdart"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stuckdartMain"},[_c('h1',[_vm._v("Achtung: Dart steckt fest")])])}]

export { render, staticRenderFns }